let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dNsh7")).then(() => parcelRequire('cRUF7'));